import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getBankProviders } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import { GetBankProviderResponse } from '@/modules/bank/type'

export default function useQueryGetBankProvider(
	props?: UseBaseQueryOptions<GetBankProviderResponse[]>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.BankProviders],
		queryFn: () => getBankProviders(),
		...props,
	})
}
